import { profileTable, supabaseClient } from '$lib/supabase';
import { v4 as uuidv4 } from 'uuid';

export const selectOrInsertProfile = async (
	email: string,
	wallet: string
): Promise<{ id: string; member: boolean; wallet: string | null }> => {
	const { data } = await profileTable('profiles').select('*').eq('email', email);

	if (!data || !data.length) {
		const uuid = uuidv4();
		const { error } = await profileTable('profiles').insert({
			id: uuid,
			wallet,
			email
		});

		if (error) {
			console.log(error);
			throw new Error('Failed to insert profile data');
		}

		// Trigger email notification via secure RPC
		await supabaseClient.rpc('queue_welcome_notification', { user_id: uuid });

		return { id: uuid, member: false, wallet };
	}
	// return an object that returns an id and member
	return { id: data[0].id, member: data[0].member, wallet: data[0].wallet };
};
